import { DateTime } from "luxon";
import { apiAddress } from "../../config/server";
import { IAvailability } from "../../types/availabilities/Availabilities";
import { ApiBase, GenericTransport } from "./baseApi";

export default class AvailabilitiesApi extends ApiBase {
  static URL = `${apiAddress}/api/availabilities/`;

  static getMyActivities(): Promise<IAvailability[]> {
    return AvailabilitiesApi.get<{
      regular: IAvailability[];
      recurring: IAvailability[];
    }>(this.URL).then((resp) => [
      ...(resp.data.data.regular || []),
      ...(resp.data.data.recurring || []),
    ]);
  }

  static createUnavailability(
    availability: IAvailability,
  ): Promise<IAvailability> {
    return AvailabilitiesApi.post<IAvailability>(this.URL, availability).then(
      (resp) => {
        const avail = resp.data.availabilities?.[0];
        if (!avail) {
          throw new Error(
            `An unexpected error occurred: ${JSON.stringify(resp.data)}`,
          );
        }
        return avail;
      },
    );
  }

  static deleteAvailability(availabilityId: string): Promise<IAvailability> {
    if (!availabilityId) throw new Error("An internal error occurred");
    return AvailabilitiesApi.delete<null>(this.URL + availabilityId).then(
      (resp) => {
        const avails = resp.data.availabilities || [];
        if (avails.length != 1) throw new Error("Unknown response from server");
        return avails[0];
      },
    );
  }

  static getAvailabilities(person: string, options: { shiftContext?: string, start?: DateTime }): Promise<IAvailability[]> {

    const urlParams = this.prepareQueryParams({
      shiftContext: options?.shiftContext,
      start: options?.start?.toISODate(),
    });
    const url = `${this.URL}${person}${urlParams}`;

    return AvailabilitiesApi.get<{
      regular: IAvailability[];
      recurring: IAvailability[];
    }>(url).then((resp) => [
      ...(resp.data.data.regular || []),
      ...(resp.data.data.recurring || []),
    ]);
  }

  static async getAvailabilityLogForAssociation(
    assocation: string,
    start: DateTime,
    finish: DateTime,
  ): Promise<GenericTransport<IAvailability[]>> {
    // url log/:association
    const query = this.prepareQueryParams({
      start: start.toISODate(),
      finish: finish.toISODate(),
    });
    return AvailabilitiesApi.get<IAvailability[]>(
      `${this.URL}log/${assocation}${query}`,
    ).then((resp) => resp.data);
  }

  static async isPersonAvailable(params: { person: string, shiftContext?: string, start: DateTime, finish: DateTime, onlyManual: boolean }): Promise<boolean> {
    const { person, shiftContext, start, finish, onlyManual } = params;
    const query = this.prepareQueryParams({
      shiftContext: shiftContext,
      onlyManual: onlyManual ? 'true' : undefined,
    });

    const url = `${this.URL}is-available/${person}/${start.toISO()}/${finish.toISO()}${query}`;
    return AvailabilitiesApi.get<boolean>(url).then((resp) => resp.data.data);

  }
}
